import { FhsAxios } from "../../services/axios";
import currencies from "@/config/currencies";
import FhsCookies from "../../services/cookies";

export default {
  state: {
    sessionId: FhsCookies.getItem("sessionId") || "",
    token_data: JSON.parse(FhsCookies.getItem("token_data") || null) || null,
    clientId: FhsCookies.getItem("clientId") || "",
    userId: FhsCookies.getItem("userId") || "",
    userName: FhsCookies.getItem("userName") || "",
    authKey: FhsCookies.getItem("authKey") || "",
    iin: FhsCookies.getItem("iin") || "",
    bin: FhsCookies.getItem("bin") || "",
    userEmail: FhsCookies.getItem("userEmail") || "",
    // Указывает на то, является пользователь VIP или нет
    isUserVIP: FhsCookies.getItem("isUserVIP") || 0,
    aisUserName: FhsCookies.getItem("aisUserName") || "",
    is_legal: parseInt(FhsCookies.getItem("is_legal") || null),
    systemStatus: FhsCookies.getItem("systemStatus") || null,
    // Валюта, отображение которой пользователь выбрал в данные момент. Выбор осуществляется в вверху Главной страницы
    displayingCurrency: "KZT",
    bankAccounts: [],
    companyName: null,
    // Портфель ценных бумаг, имеющихся у пользователя
    vp: null,
    user_profile: null,
    pre_logout: false,
    session_timer: null
  },
  actions: {
    userChangePassword({ _ }, payload) {
      let data = {
        uid: payload.uid,
        oldpass: payload.oldpass,
        newpass: payload.newpass,
        repeatedNewPass: payload.repeatedNewPass
      };
      let url = "/user/login";
      if (payload.byEds) {
        data = {
          iin: payload.iin,
          serialNumber: payload.serialNumber,
          name: payload.name,
          validity: payload.validity,
          publisherName: payload.publisherName,
          algorithm: payload.algorithm,
          pem: payload.pem,
          authorityKeyIdentifier: payload.authorityKeyIdentifier
        };
        url = "/user/login/eds";
      }
      return new Promise((resolve, reject) => {
        FhsAxios.post(url, data)
          .then(response => {
            resolve(response);
          })
          .catch(response => {
            reject(response);
          });
      });
    },
    fetchUserProfile({ commit, getters }) {
      return FhsAxios.get(`user/get-user-profile`, {
        data: {}
      }).then(res => {
        if (res.data.status) {
          commit("setUserProfileData", res.data.result);
        } else {
          commit("setUserProfileData", {});
        }
      });
    },
    fetchClientInfo({ commit, getters }) {
      commit("unsetUserInfo");
      commit("setPortfoliosList", null);
      FhsAxios.post("broker/client-info", {}).then(response => {
        if (response.data.status) {
          let portfolios = response.data.result.system_delimiters;
          if (portfolios && portfolios.length == 1) {
            commit("setSelectedPortfolio", portfolios[0].id);
          }
          FhsCookies.setItem("aisUserName", response.data.result.name);
          commit("setUserInfo", response.data.result.name);
          commit("setPortfoliosList", portfolios);
        }
      });
    },
    getUserSystemStatus({ getters }) {
      let url = `user/get-system-status`;
      return FhsAxios.get(url, {
        data: {}
      });
    },
    fetchUserData({ commit, getters }) {
      // Создаем базовый url для запроса
      let url = "user/account-total-balance";
      // Если пользователь - VIP и пользователь выбрал определенного брокера, добавляем в запрос ID брокера (получаем данные только по выбранному брокеру)
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }
      return new Promise((resolve, reject) => {
        FhsAxios.get(url, {
          data: {}
        })
          .then(response => {
            commit("setUserBalance", response.data.result.total);
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fetchAccountData({ commit, getters }) {
      // Создаем базовый url для запроса
      let url = "user/account/full";
      // Если пользователь - VIP и пользователь выбрал определенного брокера, добавляем в запрос ID брокера (получаем данные только по выбранному брокеру)
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }

      return new Promise((resolve, reject) => {
        FhsAxios.get(url, {
          data: {}
        })
          .then(response => {
            commit("setVp", response.data.result.vp);
            commit("setBankAccounts", response.data.result.bank_accounts);
            commit("setCurrencyPortfolio", response.data.result.money);
            commit("setTotalMoneyInTenge", response.data.result.total_money);
            commit("setCompanyName", response.data.result.user.company_name);
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fetchContact({ commit, getters }) {
      FhsAxios.post("contacts/get-contacts", {
        //Data
      }).then(response => {
        commit("setUserContact", response.data.result.contacts);
      });
    },
    changeCurrency({ commit, dispatch }, newCurrency) {
      commit("unsetIncomeData");
      commit("setDisplayingCurrency", newCurrency);
      dispatch("fetchIncomeData");
      dispatch("fetchIncomeSinceYearBeginning");
      try {
        dispatch("fetchAssetDynamics");
      } catch (e) {
        console.log(e);
      }
    },
    downloadUserGuide({ getters }) {
      return FhsAxios.get("document/get-user-manual", {
        data: {}
      });
    }
  },
  mutations: {
    setTokenData(state, payload = null) {
      if (payload) {
        let min_diff = payload.access_expired_at - payload.issued_at;
        //let my_deadline = new Date();
        //let total_deadline = new Date();
        //my_deadline.setSeconds(my_deadline.getSeconds() + min_diff - 70);
        //total_deadline.setSeconds(total_deadline.getSeconds() + min_diff - 10);
        let token_data = {
          loop_time: (min_diff - 30) * 1000, //Time to auto-refresh (-30 сек от времени жизни Access token)
          // loop_time: 20 * 1000,
          //my_deadline: my_deadline,
          //total_deadline: total_deadline,
          issued_at: payload.issued_at,
          access_token: payload.access_token,
          access_expired_at: payload.access_expired_at,
          refresh_token: payload.refresh_token,
          refresh_expired_at: payload.refresh_expired_at
        };
        state.token_data = token_data;
        FhsCookies.setItem(
          "token_data",
          JSON.stringify(token_data),
          min_diff * 1000
        );
      } else {
        state.token_data = payload;
        FhsCookies.remove("token_data");
      }
    },
    setUserData(state, payload) {
      (state.userId = payload.user.id),
        (state.userName = payload.user.username),
        (state.clientId = payload.user.clientId),
        (state.authKey = payload.user.auth_key),
        (state.iin = payload.user.iin),
        (state.bin = payload.user.bin),
        (state.isUserVIP = payload.user.is_vip),
        (state.aisUserName = payload.aisUserName),
        (state.userEmail = payload.user.email),
        (state.is_legal = payload.user.is_legal);
      FhsCookies.setItem("userId", payload.user.id);
      FhsCookies.setItem("authKey", payload.user.auth_key);
      FhsCookies.setItem("iin", payload.user.iin);
      FhsCookies.setItem("bin", payload.user.bin);
      FhsCookies.setItem("clientId", payload.user.clientId);
      FhsCookies.setItem("userName", payload.user.username);
      FhsCookies.setItem("userEmail", payload.user.email);
      FhsCookies.setItem("user_first_name", payload.user.firstname);
      FhsCookies.setItem("user_last_name", payload.user.lastname);
      FhsCookies.setItem("isUserVIP", payload.user.is_vip);
      FhsCookies.setItem("is_legal", payload.user.is_legal);
      // FhsCookies.setItem("registrationStatus", registrationStatus);
    },
    getUserData(state) {
      // state.sessionId = FhsCookies.getItem("sessionId") || "";
      state.token_data = JSON.parse(FhsCookies.getItem("token_data")) || null;
      state.clientId = FhsCookies.getItem("clientId") || "";
      state.userId = FhsCookies.getItem("userId") || "";
      state.userName = FhsCookies.getItem("userName") || "";
      state.authKey = FhsCookies.getItem("authKey") || "";
      state.iin = FhsCookies.getItem("iin") || "";
      state.userEmail = FhsCookies.getItem("userEmail") || "";
      // Указывает на то, является пользователь VIP или нет
      state.isUserVIP = FhsCookies.getItem("isUserVIP") || 0;
      state.aisUserName = FhsCookies.getItem("aisUserName") || "";
      state.is_legal = FhsCookies.setItem("is_legal") || null;
      //
    },
    unsetUserData(state) {
      // Полностью очищаем глобальное хранилище, чтобы при входе с другого аккаунта данные были изменены
      (state.token_data = null),
        (state.userId = ""),
        (state.userName = ""),
        (state.clientId = ""),
        (state.authKey = ""),
        (state.iin = ""),
        (state.isUserVIP = 0),
        (state.userEmail = ""),
        (state.displayingCurrency = "KZT"),
        (state.bankAccounts = []),
        (state.isCaptchaRequired = false),
        (state.aisUserName = ""),
        (state.vp = null);
      FhsCookies.clear();
    },
    setUserSystemStatus(state, payload) {
      FhsCookies.setItem("systemStatus", payload);
      state.systemStatus = payload;
    },
    setUserProfileData(state, payload) {
      state.user_profile = payload;
    },
    setUserInfo(state, aisUserName) {
      state.aisUserName = aisUserName;
    },
    unsetUserInfo(state) {
      state.aisUserName = "";
    },
    setCompanyName(state, companyName) {
      state.companyName = companyName;
    },
    unsetCompanyName(state) {
      state.companyName = "";
    },
    setDisplayingCurrency(state, newCurrency) {
      state.displayingCurrency = newCurrency;
    },
    setBankAccounts(state, bankAccounts) {
      state.bankAccounts = bankAccounts;
    },
    setVp(state, vp) {
      state.vp = vp;
    },
    unsetVp(state) {
      state.vp = null;
    }
  },
  getters: {
    isLoggedIn(state) {
      if (state.token_data) {
        return true;
      } else {
        return false;
      }
    },
    aisUserName(state) {
      return state.aisUserName;
    },
    userFullname(state) {
      return {
        firstname: state.user_first_name,
        lastname: state.user_last_name
      };
    },
    userName(state) {
      return state.userName || "Unknown user";
    },
    isUserVIP(state) {
      // Проверяем, является ли пользователь VIP
      if (Number(state.isUserVIP) === 1) {
        return true;
      } else {
        return false;
      }
    },
    isUserLegal(state) {
      return state.is_legal ? true : false;
    },
    token_data(state) {
      return state.token_data;
    },
    sessionId(state) {
      return state.sessionId || "";
    },
    userId(state) {
      return state.userId;
    },
    systemStatus: state => state.systemStatus,
    getUserProfile: state => state.user_profile,
    companyName(state) {
      return state.companyName;
    },
    displayingCurrency(state) {
      return state.displayingCurrency;
    },
    // На основе выбранной валюты возвращаем иконку
    currencySign(state, getters) {
      return currencies[getters.displayingCurrency].sign;
    },
    vp(state) {
      return state.vp;
    },
    isVpLoading(state) {
      return state.vp === null;
    },
    bankAccounts(state) {
      return state.bankAccounts;
    },
    isCaptchaRequired(state) {
      return state.isCaptchaRequired;
    }
  }
};
